export default {"src":"/_next/static/image/public/images/ic_close_modal.e6fd517edb307540831d5201631ec096.svg","height":54,"width":54};